/** @jsx jsx */
import { jsx, useTheme } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography2 } from '@coursera/cds-core';
import { ClockOutlineIcon } from '@coursera/cds-icons';

import getDurationFormatted from 'bundles/enterprise-legacy-learner-home/utils/getDurationFormatted';
// CDS
import { isSearchTheme } from 'bundles/search-common/searchTheme';
import numberRenders from 'bundles/teach-course/lib/numberRenders';

import _t from 'i18n!nls/search-common';

type PropsFromCaller = {
  videosInLesson?: number;
  durationMs?: number;
  completions: number;
};

type Props = PropsFromCaller;

const SFCProductInfo = ({ videosInLesson, durationMs, completions }: Props): JSX.Element => {
  const theme = useTheme();
  if (!isSearchTheme(theme)) {
    throw new Error(
      'SFCProductInfo can only be used in the context of a SearchTheme. Wrap this component with a ThemeProvider.'
    );
  }
  const completionsFormatted = numberRenders.Formatters.largeNumber(completions);
  return (
    <div className="rc-SFCProductInfo" css={theme.shortFormContentProductInfo}>
      <div className="short-form-content-info">
        <Grid container spacing={4}>
          {durationMs && (
            <React.Fragment>
              <Grid item>
                <ClockOutlineIcon className="duration-icon" size="medium" />
              </Grid>
              <Grid item>
                <Typography2 component="span" variant="subtitleMedium" className="sfc-parent-learning-prod-names">
                  {getDurationFormatted(durationMs)}
                </Typography2>
              </Grid>
            </React.Fragment>
          )}
          {videosInLesson && (
            <React.Fragment>
              <Grid item className="bullet-point">
                <span className="bullet-point">&#8226;</span>
              </Grid>
              <Grid item>
                <Typography2 component="span" variant="bodySecondary" className="sfc-parent-learning-prod-names">
                  {_t('#{videosInLesson} videos', { videosInLesson })}
                </Typography2>
              </Grid>
            </React.Fragment>
          )}
          <Grid item>
            <Typography2 component="span" variant="bodySecondary" className="sfc-parent-learning-prod-names">
              <span css={{ marginLeft: '4px', marginRight: '8px' }}>|</span>
              {_t('#{completionsFormatted} views', { completionsFormatted })}
            </Typography2>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default SFCProductInfo;
